import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_5_4
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
    selector: 'app-visit-exemptions-exemption-5-4',
    templateUrl: './exemption_5_4.component.html',
    styleUrls: ['./exemption_5_4.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_5_4Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_5_4;

  portVisitUtils = PortvisitUtils;
  OTHER = 'Other';
  APPENDIX_3 = 'All cargo tanks (including slop tanks) are loaded or have been loaded with a flammable liquid with a flash point of ≥ 55°C,' +
    'potassium hydroxide, sodium hydroxide, phosphoric acid and/or other substances that comply with Appendix 3 of the port regulations';
  EMPTY_AND_CLEAN = 'All cargo tanks (including slop tanks) are completely empty and clean';

  reasonTypes: string[] = ['',
    'Transshipment',
    'Reparation',
    'Cleaning',
    'Waiting',
    this.OTHER
  ];

  conditionTypes: string[] = ['',
    this.APPENDIX_3,
    this.EMPTY_AND_CLEAN,
    'Cargo tanks are loaded or empty but not gas-free'
  ];

  dangerInformationFormatter = (dangerInformation: DangerInformation) => {
    return dangerInformation.name;
  };

  resetReason() {
    this.exemption.reason = '';
  }

  resetInertTanksDescription() {
    this.exemption.inertTanksDescription = '';
  }
}

